import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { Error, CustomHttpErrorResponse } from '../../../../../../common/constants/error';
import { NotificationService } from '../../../../../../common';
import { Observable, of } from 'rxjs';
import { HubTrucksInitialState, HubTrucksLoad, HubTrucksUpdate } from './hub-trucks.actions';
import { HubTrucksService } from './hub-trucks.service';
import { HubTrucksModel } from '../../models';
import { catchError, map } from 'rxjs/operators';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface TrucksStateModel {
  trucks: HubTrucksModel;
  loaded: boolean;
}

const initialState: TrucksStateModel = {
  trucks: null,
  loaded: false,
};

@State<TrucksStateModel>({
  name: 'trucks',
  defaults: initialState,
})
@Injectable()
export class HubTrucksState {
  constructor(private hubTrucksService: HubTrucksService, private notificationService: NotificationService) {}

  @Selector()
  static getState(state: TrucksStateModel): TrucksStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: TrucksStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getTrucks(state: TrucksStateModel): HubTrucksModel {
    return state.trucks;
  }

  @Action(HubTrucksLoad)
  getTrucks(
    ctx: StateContext<TrucksStateModel>,
    { payload }: HubTrucksLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.hubTrucksService.getHubTrucks(payload).pipe(
      map((trucks: HubTrucksModel) => {
        ctx.patchState({ trucks, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(HubTrucksUpdate)
  updateTrucks(
    ctx: StateContext<TrucksStateModel>,
    { payload }: HubTrucksUpdate,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.hubTrucksService.updateHubTrucks(payload.hubId, payload.hubTruckMapping).pipe(
      map((trucks: HubTrucksModel) => {
        this.notificationService.success('api.truckMapping.success.update');
        ctx.patchState({ trucks, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(HubTrucksInitialState)
  setInitialState(ctx: StateContext<TrucksStateModel>): void {
    ctx.setState(initialState);
  }
}
